import { render, staticRenderFns } from "./rcc-button.vue?vue&type=template&id=1acec553&scoped=true"
import script from "./rcc-button.vue?vue&type=script&lang=js"
export * from "./rcc-button.vue?vue&type=script&lang=js"
import style0 from "./rcc-button.vue?vue&type=style&index=0&id=1acec553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acec553",
  null
  
)

export default component.exports